var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVyzerLogoWithGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4583 20.0898L56.4394 76.7584L48.9877 89.9614L9.55493 20.0898H24.4583ZM39.3616 20.0898L46.7398 33.1643H66.1377L56.4394 50.3498L63.8911 63.5529V63.5553L88.4217 20.0898H39.3616Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVyzerLogoWithGlow);
export default __webpack_public_path__ + "static/media/vyzer-logo-with-glow.5750ff21aa333fcb495b6e2cb255312c.svg";
export { ForwardRef as ReactComponent };